import React from "react"
import PropTypes from "prop-types"
import { Flex, Button, Progress } from "antd"
import { DeleteOutlined, FileOutlined  } from "@ant-design/icons"
import { colors, spacings } from "themes/variables"
import styles from "../index.module.css"

/**
 * Individual file item with progress and delete button
 */
const FileItem = ({ file, onDelete }) => {
  return (
    <Flex vertical gap={spacings.XS} className={styles.fileItem}>
      <Flex align="center" justify="space-between">
        <Flex align="center" gap={spacings.XS} className={styles.fileInfo}>
          <FileOutlined className={styles.fileIcon} />
          <span className={styles.fileName}>{file.name}</span>
        </Flex>
        <Button
          type="text"
          icon={<DeleteOutlined />}
          onClick={() => onDelete(file)}
          className={styles.deleteButton}
        />
      </Flex>

      {/* Show progress bar if uploading */}
      {(file.status === "uploading" || (file.percent && file.percent < 100)) && (
        <div className={styles.progressWrapper}>
          <Progress
            percent={file.percent || 0}
            strokeColor={colors.primary}
            showInfo={true}
            format={(percent) => `${percent}% done`}
            className={styles.progress}
          />
        </div>
      )}
    </Flex>
  )
}

FileItem.propTypes = {
  file: PropTypes.shape({
    uid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string,
    percent: PropTypes.number
  }).isRequired,
  onDelete: PropTypes.func.isRequired
}

export default FileItem
